import React, {useState, useContext} from "react";

import {View,Text, BackHandler, Image}  from 'react-native'

import contexto from '../util/contexto'

import {estilos} from '../util/estilos'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import cores from '../util/cores'

import * as numeros from '../util/numeros'

import * as data from '../util/data'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical } from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {buscarPropostas as wsBuscarPropostas, excluirProposta as wsExcluirProposta} from '../ws/ws_propostas'

import {semDados} from '../componentes/SemDados'

import {carregamento} from '../componentes/Carregamento'

import {TELA_PRINCIPAL, TELA_MINHAS_PROPOSTAS, 
			TELA_DETALHE_PROPOSTA, PEDIDO_SITUACAO_ATIVO, PEDIDO_SITUACAO_CANCELADO} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Alerta from '../componentes/Alerta'



export default function TelaMinhasPropostas(){

	const {valorContexto, setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const [sincronizando, setSincronizando] = useState(true)  
   
	const [listaPropostas, setListaPropostas] = useState([])
	
	

	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true
	};


	const buscarPropostas= async ()=>{

		setSincronizando(true)

		let itens  = await wsBuscarPropostas(null, valorContexto.idUsuarioAtual);
   
		setListaPropostas(util.temConteudo(itens)?itens:[]);
    
		setSincronizando(false)
	}


	useFocusEffect(React.useCallback(() => {
		
		console.log('TelaMinhasPropostas');

		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarPropostas()
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
		
	}, []));


	const verDetalhe= async (id_proposta)=>{

		console.log("verDetalhe "+id_proposta);
		
		setValorContexto(prevState =>({...prevState, idProposta: id_proposta}));

		util.setVoltar(TELA_MINHAS_PROPOSTAS);

		navegacao.navigate(TELA_DETALHE_PROPOSTA);
	}


	const preparaParaRemover= async (id_proposta)=>{

		console.log("preparaParaRemover "+id_proposta);
		
		Alerta("Exclusão de Proposta", "Deseja realmente excluir esta proposta?", async() => removerProposta(id_proposta));
	}


	const removerProposta= async (id_proposta)=>{

		console.log("excluirProposta "+id_proposta);
			
		setSincronizando(true);
		
		if(await wsExcluirProposta(id_proposta) !=null)
			buscarPropostas();
		else{
			
			setSincronizando(false);
			
			util.alertaErroGenerico();
		}
	}


	return (

		<ViewDegradeVertical titulo="Minhas Propostas" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					{util.temConteudo(listaPropostas)?
						(listaPropostas.map((item, index) => itemLista(item, index))):
						(<Bloco todaArea={true}> 
							{semDados("info", "Nenhum orçamento cadastrado.", 60)}
						</Bloco>)
					}
				</Scroll> 
				)
			}
      </ViewDegradeVertical>
   	);


	function itemLista(item, index){

		return (
			<Bloco key={index}> 
				<View style={{marginTop:5}}/>
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}> 
						<Text style={estilos.rotulo_menor}>Enviando em: {data.converteDataEuaParaBr(item.data_criacao)}</Text>
					</View>
					{item.situacao_pedido != PEDIDO_SITUACAO_CANCELADO && 
						<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
							<Text style={estilos.rotulo_menor}>{item.situacao_pedido == PEDIDO_SITUACAO_ATIVO?'Expira':'Expirou'} em: {data.converteDataEuaParaBr(item.data_criacao)}</Text>
						</View>
					}
				</View>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Text style={estilos.rotulo_titulo}>{util.getDescricaoSituacaoPedido(item.situacao_pedido)}</Text>
					</View>
					<View >
						{item.melhor_proposta>0 && 
							<View style={[estilos.grade, {marginTop: 8}]}>
								<Text style={{fontWeight: "bold",color: cores.azul}}>Melhor proposta</Text>
								<Image source={require("../imgs/checado.png")} style={{height: 18, width: 18, marginLeft:10, marginTop:0}}/>
							</View>
								
						}
					</View>
				</View>
				<Text style={estilos.rotulo_titulo}>{item.titulo}</Text>
				
				<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 100)}</Text>
				
				<View>  
					<Text style={estilos.rotulo_padrao}>Valor Total (R$): {numeros.formataNumeroParaMostrar(item.valor)}</Text>
				</View>
				
				<View style={{marginTop:25}}/>
				
				<View style={estilos.grade}>
					<View style={estilos.coluna}/> 
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Botao 
							acao={()=>verDetalhe(item.id)}
							somente_texto={true}
							texto="Detalhar"/>   
					</View>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Botao 
							acao={()=>preparaParaRemover(item.id)}
							somente_texto={true}
							texto="Excluir"
							cor={cores.vermelho}/>   
					</View>
				</View>
				<View style={{marginTop:5}}/>
			</Bloco>	
		)
	}
	
										
												
													
	
}